import { Button } from "@mui/material";
import React from "react";
import { PDFDocument, rgb } from "pdf-lib";
import sinav_salonu_pdf from "../../../../files/pdfBackgrounds/2026/sinav_salonu.pdf";
import arimoFont from "../../../../files/fonts/Arimo-Regular.ttf";

import fontkit from "@pdf-lib/fontkit";

const CM = 72 / 2.54; // 1 cm = 28.35 pt
const FONT_SIZE = 24;
const MIN_FONT_SIZE = 10;
const MIN_WRAP_FONT_SIZE = 14;
const RIGHT_MARGIN = 1.5 * CM;

// Konumlar sayfanın sol üst köşesine göre cm cinsinden (x: soldan, y: üstten).
// y metnin üst hizasıdır.
const FIELDS = {
  name: { x: 8.09, y: 5.14 },
  email: { x: 4.33, y: 7.01 },
  room: { x: 8.09, y: 8.87 },
};

export const createSinavSalonuPdf = async ({
  templateBytes,
  fontBytes,
  userName,
  email,
  examRoomInfo,
}) => {
  const pdfDoc = await PDFDocument.load(templateBytes);
  pdfDoc.registerFontkit(fontkit);
  const customFont = await pdfDoc.embedFont(fontBytes);
  const page = pdfDoc.getPages()[0];
  // Şablonun sayfa kutusu (0,0)'dan başlamıyor, bu yüzden konumlar kutunun
  // kendi sol üst köşesine göre hesaplanıyor.
  const {
    x: boxLeft,
    y: boxBottom,
    width: pageWidth,
    height: pageHeight,
  } = page.getCropBox();
  const pageTop = boxBottom + pageHeight;
  // Tasarımdaki konumlar metin kutusunun üstünü veriyor; taban çizgisini
  // bulmak için fontun ascent değeri kullanılıyor.
  const fkFont = customFont.embedder.font;
  const ascent = fkFont.ascent / fkFont.unitsPerEm;

  const drawField = (text, { x, y }, wrap = false) => {
    const left = boxLeft + x * CM;
    const maxWidth = pageWidth - x * CM - RIGHT_MARGIN;

    // Sığmayan metni önce küçült, en küçük boyutta da sığmıyorsa satıra böl.
    const minSize = wrap ? MIN_WRAP_FONT_SIZE : MIN_FONT_SIZE;
    let size = FONT_SIZE;
    while (
      size > minSize &&
      customFont.widthOfTextAtSize(text, size) > maxWidth
    ) {
      size -= 1;
    }

    page.drawText(text, {
      x: left,
      y: pageTop - y * CM - ascent * size,
      size,
      color: rgb(0, 0, 0),
      font: customFont,
      ...(wrap && { maxWidth, lineHeight: size * 1.25 }),
    });
  };

  drawField(userName || "", FIELDS.name);
  drawField(email || "", FIELDS.email);
  drawField(examRoomInfo || "", FIELDS.room, true);

  return pdfDoc.save();
};

export const SinavSalonuDocument2026 = (props) => {
  const onDownload = async () => {
    const [templateBytes, fontBytes] = await Promise.all([
      fetch(sinav_salonu_pdf).then((res) => res.arrayBuffer()),
      fetch(arimoFont).then((res) => res.arrayBuffer()),
    ]);

    const pdfBytes = await createSinavSalonuPdf({
      templateBytes,
      fontBytes,
      userName: props.userName,
      email: props.email,
      examRoomInfo: props.examRoomInfo,
    });

    var blob = new Blob([pdfBytes], { type: "application/pdf" });
    var link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = props.userName + " (Sınav Salonu).pdf";
    link.click();
  };

  return (
    <Button
      variant="contained"
      color="secondary"
      style={{
        minWidth: 280,
        height: 60,
        fontSize: "16px",
        fontWeight: "bold",
        textTransform: "none",
        padding: "12px 24px",
      }}
      onClick={onDownload}
    >
      Sınav Salonu Bilgilendirme
    </Button>
  );
};
